import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Card, Space } from 'antd'
import { Outlet } from 'react-router-dom'

const OneTimeCodesContainer = () => {
  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={translate('menuBar.oneTimeCodesTitle')}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

export default OneTimeCodesContainer
